import React, { Children, Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { arrayOf, bool, func, number } from "prop-types";
import { actions as depositsActions, selectors as depositsSelectors } from "reducers/deposits";

import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import classNames from "classnames";
import gaEventTracker, { events } from "util/gaEventTracker";
import { isIOS } from "react-device-detect";
import DepositRateList from "./_components/DepositRateList";
import Box from "pages/_components/Box";

const DepositTabRates = ({ depositsRates, dispatch, fetching, position, ...props }) => {
    const [selectedFilter, setSelectedFilter] = useState("ARS");

    const selectedDepositType = position === 0 ? "PF" : "TRANS";

    useEffect(() => {
        gaEventTracker.triggerEvent(events.pf_consulta_tasas());
        dispatch(depositsActions.listDepositsRates(selectedDepositType, selectedFilter));
    }, [dispatch, selectedFilter]);

    const handleFilterButtonsClick = (id) => {
        setSelectedFilter(id);
    };

    const filters = [
        <CustomButton
            className={classNames("btn btn-outline", {
                "is-active": selectedFilter === "ARS",
                "filter-ios": isIOS,
            })}
            key="ARS"
            text="deposits.rates.filters.currency.ARS"
            textType="I18N"
            func={() => handleFilterButtonsClick("ARS")}
        />,
        <CustomButton
            className={classNames("btn btn-outline", {
                "is-active": selectedFilter === "USD",
                "filter-ios": isIOS,
            })}
            key="USD"
            text="deposits.rates.filters.currency.USD"
            textType="I18N"
            func={() => handleFilterButtonsClick("USD")}
        />,
    ];

    return (
        <Fragment>
            {filters && (
                <ul className={isIOS ? "nav nav-pills row my-7 justify-content-between" : "nav nav-pills row my-7"}>
                    {Children.map(filters, (child) => (
                        <li style={!isIOS ? { flex: 1 } : null}>{child}</li>
                    ))}
                </ul>
            )}

            {depositsRates.length ? (
                <Fragment>
                    <DepositRateList depositsRates={depositsRates} currency={selectedFilter} {...props} />
                </Fragment>
            ) : (
                <Box className="box info service-payments__no-data">
                    <Image src="images/information_fill.svg" />
                    <I18n id="deposits.rates.noData" />
                </Box>
            )}
        </Fragment>
    );
};

DepositTabRates.propTypes = {
    depositsRates: arrayOf({ length: number.isRequired }),
    dispatch: func.isRequired,
    position: number.isRequired,
    fetching: bool,
};

DepositTabRates.defaultProps = {
    depositsRates: [],
    fetching: false,
};

const mapStateToProps = (state) => ({
    depositsRates: depositsSelectors.getDepositsRates(state),
    fetching: depositsSelectors.getFetching(state),
});

export default connect(mapStateToProps)(DepositTabRates);
